/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BuildingApi } from '../api/building.api';
import { switchMap, map } from 'rxjs/operators';
import { BuildingData, Building } from '../../../interfaces/masters/building';

@Injectable()
export class BuildingService extends BuildingData {

  constructor(private api: BuildingApi) {
    super();
  }


  list(url: string): Observable<Building[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Building>{
      return this.api.getById(url);
  }

  create(url: string, data:Building): Observable<Building[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Building): Observable<Building> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
